function initProductPage(section) {
  if (!section || !section.classList.contains("product-section")) {
    return;
  }

  const initMainSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-media-list");
    if (!sliderEl) return;

    const desktopType = sliderEl.dataset?.desktopType || "slider";
    const mobileType = sliderEl.dataset?.mobileType || "slider";
    const hasDesktopZoom = sliderEl.dataset?.hasDesktopZoom === "true";
    const navPrev = sliderEl.querySelector(".swiper-button-prev");
    const navNext = sliderEl.querySelector(".swiper-button-next");
    const mediaBox = sliderEl.closest(".product__media");
    const thumbsSlider = mediaBox?.querySelector(".js-media-sublist");

    // Variant media grouping toggles slides in place; loop mode duplicates
    // slides and desyncs after filtering, so keep it off when grouping is on.
    const altMediaGrouping =
      mediaBox?.dataset?.altMediaGrouping === "true";

    const isLoop =
      !altMediaGrouping &&
      sliderEl.querySelectorAll(".swiper-slide").length > 2;
    const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
    const speed = slideCount > 30 ? 0 : 800;

    const initialSlide =
      !isLoop && sliderEl.dataset?.initialSlide
        ? parseInt(sliderEl.dataset.initialSlide, 10) || 0
        : 0;

    const initSwiper = () => {
      new Swiper(sliderEl, {
        slidesPerView: mobileType === "slider" ? "auto" : 1,
        spaceBetween: 0,
        autoHeight: false,
        loop: isLoop,
        initialSlide: initialSlide,
        direction: "horizontal",
        speed: speed,
        allowTouchMove: true,
        mousewheel: {
          forceToAxis: true,
        },
        navigation: {
          nextEl: navNext,
          prevEl: navPrev,
        },
        breakpoints: {
          990: {
            slidesPerView: desktopType === "slider" ? "auto" : 1,
            allowTouchMove: !hasDesktopZoom,
          },
        },
        thumbs: {
          swiper: thumbsSlider?.swiper ? thumbsSlider.swiper : "",
        },
        on: {
          slideChange: function () {
            //window.pauseAllMedia();
            window.pauseAllModels();
            this.params.noSwiping = false;
          },
          slideChangeTransitionEnd: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            const posterBtn3D = this.slides[activeIndex]?.querySelector(
              ".shopify-model-viewer-ui__button--poster"
            );
            if (model3D && posterBtn3D) {
              posterBtn3D.removeAttribute("hidden");
            }
          },
          touchStart: function () {
            const activeIndex = isLoop ? this.realIndex : this.activeIndex;
            const model3D =
              this.slides[activeIndex]?.querySelector("model-viewer");
            if (model3D) {
              if (
                !model3D.classList.contains("shopify-model-viewer-ui__disabled")
              ) {
                this.params.noSwiping = true;
                this.params.noSwipingClass = "swiper-slide";
              } else {
                this.params.noSwiping = false;
              }
            }
          },
        },
      });
    };

    const destroySwiper = () => {
      if (sliderEl.swiper) {
        sliderEl.swiper.destroy();
      }
      sliderEl.querySelectorAll(".swiper-wrapper").forEach((wrapper) => {
        wrapper.removeAttribute("style");
      });
      sliderEl.querySelectorAll(".swiper-slide").forEach((slide) => {
        slide.removeAttribute("style");
      });
    };

    const hasDesktopSwiper =
      desktopType === "slider" || desktopType == "slider_previews";
    const hasMobileSwiper =
      mobileType === "slider" || mobileType == "slider_previews";

    // ROBA LUCA 04/10/2026: de pijltjes op mobiel sprongen heen en weer
    // of deden niets. Zenith keek hier met een ResizeObserver naar de hele
    // sectie, en maakte bij elke maatverandering een nieuwe Swiper op
    // dezelfde galerij zonder de vorige op te ruimen. Een uitklapblok
    // open of dicht, een foto of lettertype dat laadt: telkens één slider
    // erbij. Na een paar keer stuurde één tik vier, vijf sliders tegelijk
    // en werkten die elkaar tegen. Zie §76.
    //
    // Slider of niet hangt alleen af van de breedte: 990 px, dezelfde
    // grens als de breakpoints hierboven en de zoom (§32). We luisteren
    // dus enkel naar het overschrijden van die grens. Meeschalen met de
    // galerij doet Swiper zelf (resizeObserver staat standaard aan).
    // En er komt nooit een tweede Swiper op dezelfde galerij, ook niet
    // als initProductPage opnieuw draait.
    if (hasDesktopSwiper && hasMobileSwiper) {
      if (!sliderEl.swiper) initSwiper();
    } else {
      const desktopQuery = window.matchMedia("(min-width: 990px)");

      const syncSwiper = () => {
        // Zenith heeft de galerij vervangen: deze luisteraar hoort bij de
        // oude en ruimt zichzelf op. De nieuwe galerij krijgt er een eigen.
        if (!sliderEl.isConnected) {
          desktopQuery.removeEventListener("change", syncSwiper);
          return;
        }

        const wantsSwiper = desktopQuery.matches
          ? hasDesktopSwiper
          : hasMobileSwiper;

        if (!wantsSwiper) {
          destroySwiper();
          return;
        }

        if (!sliderEl.swiper) initSwiper();
      };

      syncSwiper();
      desktopQuery.addEventListener("change", syncSwiper);
    }
  };

  const initSubSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sliderEl = section.querySelector(".js-media-sublist");
    if (!sliderEl) return;

    const desktopType = sliderEl.dataset?.desktopType || "slider";
    const mobileType = sliderEl.dataset?.mobileType || "slider";
    const hasDesktopSwiper = desktopType === "slider_previews";
    const hasMobileSwiper = mobileType === "slider_previews";

    // See initMainSlider: loop is disabled while variant media grouping is on.
    const altMediaGrouping = !!section.querySelector(
      '[data-alt-media-grouping="true"]'
    );
    const isLoop =
      !altMediaGrouping &&
      sliderEl.querySelectorAll(".swiper-slide").length > 3;

    const initSwiper = () => {
      const thumbSlider = new Swiper(sliderEl, {
        spaceBetween: 8,
        slidesPerView: 4,
        loop: isLoop,
        direction: "horizontal",
        allowTouchMove: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        autoHeight: false,
        slideToClickedSlide: true,
        on: {
          touchEnd: function (swiper) {
            let range = 5;
            let diff = (swiper.touches.diff = swiper.isHorizontal()
              ? swiper.touches.currentX - swiper.touches.startX
              : swiper.touches.currentY - swiper.touches.startY);
            if (diff < range || diff > -range) swiper.allowClick = true;
          },
        },
        breakpoints: {
          576: {
            slidesPerView: 6,
          },
          990: {
            slidesPerView: "auto",
            direction: "vertical",
          },
        },
      });

      return thumbSlider;
    };

    if (hasDesktopSwiper || hasMobileSwiper) {
      initSwiper();

      const resizeObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => {
          if (sliderEl.swiper) {
            if (window.innerWidth >= 990 && hasDesktopSwiper) {
              sliderEl.swiper.enable();
              sliderEl.swiper.changeDirection("vertical", true);
            }

            if (
              window.innerWidth >= 990 &&
              desktopType === "stacked_previews"
            ) {
              sliderEl.swiper.disable();
            }

            if (window.innerWidth < 990 && hasMobileSwiper) {
              sliderEl.swiper.enable();
              sliderEl.swiper.changeDirection("horizontal", true);
            }
          }
        });
      });

      resizeObserver.observe(section);
    }
  };

  const initZoomSlider = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const sectionBox = section.querySelector('[id^="MainProduct-"]');
    const sectionId = sectionBox?.dataset?.section;
    const sliderEl = document.querySelector(
      `[data-section-id='${sectionId}'].js-popup-slider`
    );
    if (!sliderEl) return;

    const buttonPrev = sliderEl.querySelector(".swiper-button-prev");
    const buttonNext = sliderEl.querySelector(".swiper-button-next");

    // See initMainSlider: loop is disabled while variant media grouping is on so
    // the zoom slider stays in sync with the filtered, in-place media set.
    const altMediaGrouping = !!section.querySelector(
      '[data-alt-media-grouping="true"]'
    );
    const isLoop =
      !altMediaGrouping &&
      sliderEl.querySelectorAll(".swiper-slide").length > 3;
    const slideCount = sliderEl.querySelectorAll(".swiper-slide").length;
    const speed = slideCount > 30 ? 0 : 800;

    // ROBA LUCA 23/09/2026: mini-beeldjes en scrollen in de zoom.
    // Uitleg: docs/shop/theme-custom-code.md §32.
    // Vanaf 990 px staat de foto over de volle breedte en scroll je er
    // verticaal door (opmaak in rl-custom.css §15). Daar is de foto al op
    // ware grootte, dus de dubbelklik-zoom van Swiper gaat er uit: die
    // maakt hem alleen waziger. Onder 990 px blijft die zoom, voor duim
    // en wijsvinger.
    const thumbsEl = document.querySelector(
      `[data-section-id='${sectionId}'].product-media-modal__thumbs`
    );
    const thumbEls = thumbsEl
      ? Array.from(thumbsEl.querySelectorAll(".product-media-modal__thumb"))
      : [];
    const desktopQuery = window.matchMedia("(min-width: 990px)");

    const setActiveThumb = (swiper) => {
      thumbEls.forEach((thumb, index) => {
        const isActive = index === swiper.realIndex;
        thumb.classList.toggle("is-active", isActive);
        if (isActive) {
          thumb.setAttribute("aria-current", "true");
          thumbsEl.scrollTo({
            top: thumb.offsetTop - (thumbsEl.clientHeight - thumb.offsetHeight) / 2,
            behavior: "smooth",
          });
        } else {
          thumb.removeAttribute("aria-current");
        }
      });
    };

    const syncZoomToViewport = () => {
      const swiper = sliderEl.swiper;
      if (!swiper?.zoom) return;
      if (desktopQuery.matches) {
        if (swiper.zoom.scale > 1) swiper.zoom.out();
        swiper.zoom.disable();
      } else {
        swiper.zoom.enable();
      }
    };

    // ROBA LUCA 26/09/2026: pijltjestoetsen links/rechts in de zoom.
    // Bewust niet Swipers eigen `keyboard`-module: die luistert op de
    // hele pagina en ziet de gesloten popup als 'in beeld' (hij staat
    // vast op het scherm, enkel onzichtbaar), dus de pijltjes zouden op
    // de productpagina zelf al stilletjes van foto wisselen. Deze
    // listener zit op de popup: toetsen komen hier alleen aan wanneer
    // de focus erin staat, en dat is alleen zo als hij open is (Zenith
    // zet de focus op de dialoog bij het openen). Zie §32.
    const rlModal = sliderEl.closest("product-modal");
    // Zie de uitleg bij de controle op sliderEl.swiper hieronder: bij een
    // tweede doorloop mag deze listener er niet nog eens bij komen.
    if (rlModal && !rlModal.dataset.rlKeys) {
      rlModal.dataset.rlKeys = "1";
      rlModal.addEventListener("keydown", (event) => {
        if (!sliderEl.swiper || event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === "ArrowLeft") {
          event.preventDefault();
          sliderEl.swiper.slidePrev();
        } else if (event.key === "ArrowRight") {
          event.preventDefault();
          sliderEl.swiper.slideNext();
        }
      });
    }

    const onMainSliderToggleClick = (event) => {
      if (!sliderEl.swiper) return;
      const zoomToggle = event.target.closest(".product__media-toggle");
      if (!zoomToggle) return;
      const mediaId = zoomToggle.dataset?.mediaId;
      if (!mediaId) return;
      const realSlides = Array.from(
        sliderEl.querySelectorAll(".product-media-modal__item.swiper-slide")
      ).filter((slide) => !slide.classList.contains("swiper-slide-duplicate"));

      const realIndex = realSlides.findIndex((slide) =>
        slide.querySelector(`[data-media-id="${mediaId}"]`)
      );

      if (realIndex !== -1) {
        // ROBA LUCA 05/10/2026 (§86): eerst de maten opnieuw rekenen,
        // dan naar de foto. Andersom zette update() de popup terug op
        // de foto die Swiper nog als actief kende. Met native scroll
        // (cssMode, assets/rl-swiper.js) kent Swiper de nieuwe foto
        // pas na het scroll-event, dus opende de popup altijd op de
        // eerste foto.
        sliderEl.swiper.update();
        if (sliderEl.swiper.params.loop) {
          sliderEl.swiper.slideToLoop(realIndex, 0);
        } else {
          sliderEl.swiper.slideTo(realIndex, 0);
        }
      }
      // ROBA LUCA: elke foto opent bovenaan, niet waar je de vorige keer stopte.
      sliderEl.swiper.slides.forEach((slide) => {
        slide.scrollTop = 0;
      });
    };

    // ROBA LUCA 26/09/2026: Zenith roept initProductPage opnieuw aan nadat
    // het bij een andere variant de galerij heeft vervangen (instelling
    // "hide unselected variant media"). De zoompopup zelf vervangt Zenith
    // dan niet: die draait al. Dus geen tweede Swiper en geen tweede set
    // listeners op dezelfde popup; alleen de nieuwe foto's op de pagina
    // krijgen hun klik naar de popup terug. Zie §38.
    if (sliderEl.swiper) {
      section
        .querySelectorAll(".product__media-list .product__media-toggle")
        .forEach((elem) => {
          elem.addEventListener("click", onMainSliderToggleClick);
        });
      return;
    }

    new Swiper(sliderEl, {
      slidesPerView: 1,
      speed: speed,
      loop: isLoop,
      zoom: {
        maxRatio: 2,
      },
      // ROBA LUCA 24/09/2026: geen mousewheel in de zoom (was
      // { forceToAxis: true }). Verticaal scrollen gaat door de foto.
      // Een trackpad drijft aan het eind van zo'n beweging vaak een paar
      // pixels opzij, en dat zag Swiper als 'volgende foto'. Wisselen
      // gaat via de mini-beeldjes, de pijlen of vegen. Zie §32.
      navigation: {
        nextEl: buttonNext,
        prevEl: buttonPrev,
      },
      on: {
        afterInit: function () {
          section
            .querySelectorAll(".product__media-list .product__media-toggle")
            .forEach((elem) => {
              elem.addEventListener("click", onMainSliderToggleClick);
            });

          // ROBA LUCA: mini-beeldjes en zoom per schermbreedte (§32).
          const swiper = this;
          thumbEls.forEach((thumb, index) => {
            thumb.addEventListener("click", () => {
              if (swiper.params.loop) {
                swiper.slideToLoop(index);
              } else {
                swiper.slideTo(index);
              }
            });
          });
          syncZoomToViewport();
          desktopQuery.addEventListener("change", syncZoomToViewport);
        },
        slideChange: function () {
          //window.pauseAllMedia();
          window.pauseAllModels();
          this.params.noSwiping = false;
          sliderEl.classList.remove("zoom");
          // ROBA LUCA (§32): de nieuwe foto begint bovenaan, en het
          // bijhorende mini-beeldje licht op.
          const incoming = this.slides[this.activeIndex];
          if (incoming) incoming.scrollTop = 0;
          setActiveThumb(this);
        },
        touchMove: function () {
          sliderEl.classList.remove("zoom");
        },
        slideChangeTransitionEnd: function () {
          const activeIndex = isLoop ? this.realIndex : this.activeIndex;
          const model3D =
            this.slides[activeIndex]?.querySelector("model-viewer");
          const posterBtn3D = this.slides[activeIndex]?.querySelector(
            ".shopify-model-viewer-ui__button--poster"
          );
          if (model3D && posterBtn3D) {
            posterBtn3D.removeAttribute("hidden");
          }
        },
        touchStart: function () {
          const activeIndex = isLoop ? this.realIndex : this.activeIndex;
          const model3D =
            this.slides[activeIndex]?.querySelector("model-viewer");
          if (model3D) {
            if (
              !model3D.classList.contains("shopify-model-viewer-ui__disabled")
            ) {
              this.params.noSwiping = true;
              this.params.noSwipingClass = "swiper-slide";
            } else {
              this.params.noSwiping = false;
            }
          }
        },
      },
    });
  };

  const initStackedPreviews = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const mediaList = section.querySelector(
      ".product__media-list[data-desktop-type='stacked_previews']"
    );
    const thumbs = section.querySelector(
      ".product__media-sublist[data-desktop-type='stacked_previews']"
    );
    if (!mediaList || !thumbs) return;

    const mediaEls = Array.from(mediaList.querySelectorAll("[data-media-id]"));
    const thumbEls = Array.from(thumbs.querySelectorAll("[data-media-sub-id]"));

    const setActiveThumb = (mediaId) => {
      thumbEls.forEach((thumb) => {
        thumb.classList.toggle("active", thumb.dataset.mediaSubId === mediaId);
      });

      const activeThumb = thumbs.querySelector(
        `[data-media-sub-id="${mediaId}"]`
      );
      if (!activeThumb) return;
      const thumbHeight = activeThumb.offsetHeight;
      const activeIndex = thumbEls.findIndex(
        (el) => el.dataset.mediaSubId === mediaId
      );

      const nextIndex = Math.min(activeIndex + 1, thumbEls.length - 1);

      const scrollTarget =
        thumbEls[nextIndex].offsetTop - thumbs.clientHeight / 2 + thumbHeight;

      thumbs.scrollTo({
        top: scrollTarget,
        behavior: "smooth",
      });
    };

    const onScroll = () => {
      if (window.innerWidth < 990) return;
      const viewportMiddle = window.scrollY + window.innerHeight / 2;

      let closestMedia = null;
      let closestDistance = Infinity;

      for (const mediaEl of mediaEls) {
        const rect = mediaEl.getBoundingClientRect();
        const mediaTop = window.scrollY + rect.top;
        const distance = Math.abs(mediaTop - viewportMiddle);

        if (mediaTop < viewportMiddle && distance < closestDistance) {
          closestDistance = distance;
          closestMedia = mediaEl;
        }
      }

      if (closestMedia) {
        setActiveThumb(closestMedia.dataset.mediaId);
      }
    };

    requestAnimationFrame(() => {
      onScroll();
    });

    window.addEventListener("scroll", onScroll, { passive: true });

    thumbEls.forEach((thumb) => {
      thumb.addEventListener("click", (e) => {
        if (window.innerWidth < 990) return;
        const mediaId = thumb.dataset.mediaSubId;
        const targetMedia = mediaList.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (targetMedia) {
          const offset =
            targetMedia.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({ top: offset - 100, behavior: "smooth" });
          setActiveThumb(mediaId);
        }
      });
    });
  };

  const initProductAccordion = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const accordions = section.querySelectorAll(".product-accordion");

    // ROBA LUCA 04/10/2026: één klikluisteraar per accordeon. Zenith roept
    // initProductPage opnieuw aan als het bij een variantwissel de galerij
    // vervangt (bij ons de gift card: "hide unselected variant media").
    // De accordeons blijven dan gewoon staan, maar kregen er elke keer een
    // luisteraar bij. Na een oneven aantal wissels ging een klik open en
    // meteen weer dicht. Een accordeon die al gebonden is, slaan we over;
    // een nieuwe uit een re-render krijgt er wel één. Zie §77.
    accordions.forEach((accordion) => {
      if (accordion.dataset.accordionBound) return;
      accordion.dataset.accordionBound = "true";

      accordion.addEventListener("click", (event) => {
        const toggleEl = event.target.closest(".product-accordion__toggle");
        if (!toggleEl) return;

        const contentEl = toggleEl.nextElementSibling;
        if (
          !contentEl ||
          !contentEl.classList.contains("product-accordion__content")
        ) {
          return;
        }

        const isActive = toggleEl.classList.contains("active");
        if (!isActive) {
          slideDown(toggleEl, contentEl, 300); // func in global.js
        } else {
          slideUp(toggleEl, contentEl, 300); // func in global.js
        }
      });
    });
  };

  const initStickyAddBar = (section) => {
    if (!section || !section.classList.contains("product-section")) return;

    const buyButtons = section.querySelector(
      ".product__buy-buttons > product-form"
    );
    const stickyBar = section.querySelector(".product-sticky-add-bar");
    const footerBottom = document.querySelector(
      ".shopify-section-group-footer-group .footer-bottom"
    );

    if (!stickyBar) return;

    const observerOptions = {
      root: null,
      rootMargin: "0px",
      threshold: 0.01,
    };

    const isElementBelowScroll = (element) => {
      return element ? element.getBoundingClientRect().top > 0 : false;
    };

    const toggleStickyBar = (isVisible) => {
      if (isVisible || isElementBelowScroll(buyButtons)) {
        stickyBar.classList.remove("active");
      } else {
        stickyBar.classList.add("active");
      }
    };

    const handleIntersect = (entries) => {
      const isVisible = entries.some((entry) => entry.isIntersecting);
      toggleStickyBar(isVisible);
    };

    const observer = new IntersectionObserver(handleIntersect, observerOptions);

    if (buyButtons) observer.observe(buyButtons);
    if (footerBottom) observer.observe(footerBottom);
  };

  let isZoomCursorInit = false;
  const initZoomCursor = (section) => {
    if (!section || !section.classList.contains("product-section")) {
      return;
    }

    const mediaWrapper = section.querySelector(".product__media-list");
    const hasZoom =
      mediaWrapper.getAttribute("data-has-desktop-zoom") === "true";
    if (!hasZoom) return;

    const cursorEl = section.querySelector(".product__media-cursor");
    if (!cursorEl) return;

    let currentX = 0;
    let currentY = 0;
    let targetX = 0;
    let targetY = 0;
    const easingFactor = 0.2;
    let isAnimating = false;

    const animateCursor = () => {
      isAnimating = true;

      currentX += (targetX - currentX) * easingFactor;
      currentY += (targetY - currentY) * easingFactor;

      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      if (
        Math.abs(targetX - currentX) > 0.1 ||
        Math.abs(targetY - currentY) > 0.1
      ) {
        requestAnimationFrame(() => animateCursor());
      } else {
        isAnimating = false;
      }
    };

    const handleMouseMove = (e) => {
      if (!e.target.closest(".product__media-toggle")) {
        mediaWrapper.classList.remove("cursor-active");
      } else {
        mediaWrapper.classList.add("cursor-active");
      }

      const wrapperRect = mediaWrapper.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();

      targetX = e.clientX - wrapperRect.left - cursorRect.width / 2;
      targetY = e.clientY - wrapperRect.top - cursorRect.height / 2;

      if (!isAnimating) {
        animateCursor();
      }
    };

    const handleMouseEnter = (e) => {
      const wrapperRect = mediaWrapper.getBoundingClientRect();
      const cursorRect = cursorEl.getBoundingClientRect();

      targetX = currentX = e.clientX - wrapperRect.left - cursorRect.width / 2;
      targetY = currentY = e.clientY - wrapperRect.top - cursorRect.height / 2;

      cursorEl.style.left = `${currentX}px`;
      cursorEl.style.top = `${currentY}px`;

      mediaWrapper.classList.add("cursor-active");
    };

    const handleMouseLeave = () => {
      mediaWrapper.classList.remove("cursor-active");
    };

    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.contentRect.width >= 990 &&
          window.matchMedia("screen and (hover: hover) and (pointer: fine)")
            .matches
        ) {
          if (isZoomCursorInit) return;
          mediaWrapper.addEventListener("mouseenter", handleMouseEnter);
          mediaWrapper.addEventListener("mousemove", handleMouseMove);
          mediaWrapper.addEventListener("mouseleave", handleMouseLeave);

          isZoomCursorInit = true;
        } else {
          if (!isZoomCursorInit) return;
          mediaWrapper.removeEventListener("mouseenter", handleMouseEnter);
          mediaWrapper.removeEventListener("mousemove", handleMouseMove);
          mediaWrapper.removeEventListener("mouseleave", handleMouseLeave);

          isZoomCursorInit = false;
        }
      });
    });

    resizeObserver.observe(section);
  };

  initSubSlider(section);
  initMainSlider(section);
  initZoomSlider(section);
  initStackedPreviews(section);

  initStickyAddBar(section);
  initZoomCursor(section);
  initProductAccordion(section);

  document.addEventListener("shopify:section:load", (event) => {
    initSubSlider(event.target);
    initMainSlider(event.target);
    initZoomSlider(event.target);
    initStackedPreviews(event.target);

    initStickyAddBar(event.target);
    initZoomCursor(event.target);
    if (!window.Shopify.designMode) {
      initProductAccordion(event.target);
    }
  });
}

initProductPage(document.currentScript.parentElement);
